import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseListeComponent } from '@classes/extends';
import {
    Client, ClientsService as ClientService,
    RFService, Service, ServicesService, Utilisateur
} from '@estel-numerique/galaclick-api';
import { FiltreHelper, FiltresService, OuiNon, TypeFiltre } from '@estel-numerique/galaclick-core';
import { UtilDate } from '@services/index';
import { Constantes } from '@services/util/constantes';
// Surcharge des classes de ApiGalaclick
import { ClientAdv, TypeHeadElement } from '@classes/models';
import { InventaireComponent, InventaireComponentData } from '../suiviclients/inventaire.component';
// Utilisation de la fenetre de Modif du module SuiviClient
import { MatDialog } from '@angular/material/dialog';
import { SelectFiltre } from '@composants/index';
import { lastValueFrom } from 'rxjs';
import { CreerService, CreerServiceData } from '../suiviclients/services/services-creer/services-creer.component';
import { ServiceDetailsComponent, ServiceDetailsComponentData } from "../suiviclients/services/services-details/services-details.component";
import { FiltreGala, InfoAgent } from '../composants/composants';
import { SelectFiltre as SelectFiltre_1 } from '../composants/select/select.component';
import { NgClass } from '@angular/common';
import { CpIconSort, CpIconActif } from '../composants/icons/icons.component';
import { MenuClientComponent } from '../composants/menu-context/menu-client/menu-client.component';
import { ButtonGalaComponent } from '../composants/buttons/btn-gala/btn-gala.component';
import { ButtonGalaEditComponent } from '../composants/buttons/btn-gala-edit/btn-gala-edit.component';
import { ButtonGalaSearchComponent } from '../composants/buttons/btn-gala-search/btn-gala-search.component';
import { UtilDirective } from '../directive/directive';
import { ButtonGalaDeleteComponent } from '../composants/buttons/btn-gala-delete/btn-gala-delete.component';
import { PaginationV2Component } from '../composants/paginationV2/paginationV2.component';
import { PhonePipe } from '../../services/util/pipe';

/**
  * PorteFeuille Client de l'agent
  */
@Component({
    templateUrl: './pfClientListe.component.html',
    imports: [
        FiltreGala, SelectFiltre_1, InfoAgent, NgClass, CpIconSort, MenuClientComponent, ButtonGalaComponent, ButtonGalaEditComponent, ButtonGalaSearchComponent, CpIconActif, UtilDirective,
        ButtonGalaDeleteComponent, PaginationV2Component, PhonePipe
    ]
})
export class PFClientListeComponent extends BaseListeComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private wsClient = inject(ClientService);
    private formBuilder = inject(UntypedFormBuilder);
    private wsServ = inject(ServicesService);
    private filtresService = inject(FiltresService);
    private dialog = inject(MatDialog);

    public titre: string;

    public codeModule: string = Constantes.CodeOption.OFICHIERUSER; // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)

    public idAgent: number; // Utilisé dans le cartouche

    //public typeAgent: RFParam;

    @ViewChild('selectOrganisme', { static: true }) public selectOrganisme: SelectFiltre;
    @ViewChild('selectService', { static: true }) public selectService: SelectFiltre;

    // Entete de tableau
    public headElements: TypeHeadElement[] = [];

    // Traduction
    protected lgTrad: Record<string, string> = {};
    protected lgTradFiltre: Record<string, string> = {};

    // Filtre
    //public filtreClientActif: Array<TypeFiltre> = [];
    public filtreOrganisme: TypeFiltre<number>[] = [];
    public filtreService: TypeFiltre<string>[] = [];
    public filtreActif: TypeFiltre<OuiNon>[] = [];
    public filtreHorsZone: TypeFiltre<OuiNon>[] = [];
    public filtreServActif: TypeFiltre<OuiNon>[] = [];
    public filtreTypeReferent: TypeFiltre<string>[] = [];

    public listeTypeServ: RFService[] = [];
    public listRfServices: RFService[] = [];
    public formAjout: UntypedFormGroup;

    protected accesSuiviActivite = false;

    // Action disponible a la ligne
    public selectAction: { id: number, label: string }[] = [];

    public nomPage = "PFCLIENT";

    private clientSelectionne: Client;
    get listeElementsAff() {
        return this.getListeAffichee<ClientAdv & { del: boolean }>();
    }
    constructor() {
        super();
        this.titre = this.translate.instant("APPPORTEFEUILLECLIENT.TITRE");
        this.btnCreerLabel = this.translate.instant("APPPORTEFEUILLECLIENT.BTNCREERLABEL");
        this.route.params.subscribe(params => {
            this.idAgent = params.usrid as number;
        });
        this.filtreActif = this.filtresService.getFiltreOuiNon();
        this.filtreHorsZone = this.filtresService.getFiltreOuiNon();
        this.filtreServActif = FiltreHelper.majSelectionFiltreFromListe(this.filtresService.getFiltreOuiNon(), [FiltreHelper.OuiNon.OUI]);
        this.filtreTypeReferent = this.filtresService.getFiltreTypeReferent();
        this.formAjout = this.formBuilder.group({
            TYPESERV: [null, [Validators.required]]
        });
        this.lgTrad = {
            ACTIF: this.translate.instant("APPCLIENT.ACTIF"),
            ORGANISME: this.translate.instant("APPCLIENT.ORGANISME"),
            COMMUNE: this.translate.instant("MUNICIPALITY"),
            ACTION: this.translate.instant("ACTION"),
            TOTSELECTED: this.translate.instant("FILTERS.TOTSELECTED"),
            SIG: this.translate.instant("APPCLIENT.SIG"),
            ACTIFUL: this.translate.instant("ACTIFUL"),
            CLSIG: this.translate.instant("APPCLIENT.CLSIG"),
            HORSZONE: this.translate.instant("APPCLIENT.HORSZONE")
        };
        // Traduction entête de colonne
        this.headElements = [
            { libelle: this.translate.instant("APPCLIENT.CODE"), tri: 'NUCHEP', sortable: true },
            { libelle: this.translate.instant("NAME"), tri: 'NOM', sortable: true },
            { libelle: this.translate.instant("MUNICIPALITY"), tri: 'CPVILLE', sortable: true },
            { libelle: this.translate.instant("INTERLOCUTEUR"), tri: 'CONTACT_NOMPRENOM', sortable: true },
            { libelle: this.translate.instant("APPCLIENT.TEL1"), tri: 'CONTACT_TEL1', sortable: true },
            { libelle: this.translate.instant("MAIL"), tri: '', sortable: false },
            { libelle: this.translate.instant("APPCLIENT.REFERENT"), tri: 'REFERENT.NOM', sortable: true }
        ];
        // traduction des filtres
        this.lgTradFiltre = {
            FILTRE: this.translate.instant("FILTER"),
            TOTAL: this.translate.instant("FILTERS.TOTAL"),
            ACTIF: this.translate.instant("APPPORTEFEUILLECLIENT.FILTRE.ACTIF"),
            ORGANISME: this.translate.instant("APPPORTEFEUILLECLIENT.FILTRE.ORGANISME"),
            SERVICE: this.translate.instant("APPPORTEFEUILLECLIENT.FILTRE.SERVICE"),
            DATEFILTRE: this.translate.instant("APPPORTEFEUILLECLIENT.FILTRE.DATEFILTRE"),
            TYPEREFERENT: this.translate.instant("APPPORTEFEUILLECLIENT.FILTRE.TYPEREFERENT"),
        };
    }

    ngOnInit() {
        super.ngOnInit();
        this.accesSuiviActivite = this.ctrlAccess.ctrlAccessOK(Constantes.CodeOption.CSUIVIACTCLIENT);
        this.init().catch(e => this.util.fErreur(e));
    }

    private async init() {
        this.util.showLoader();
        try {
            await this.chargeListe();
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    private async chargeListe() {
        //on charge les organismes en dehors du if car necessaire lors du appliquefiltre()
        this.filtreOrganisme = await this.filtresService.getFiltreOrga();

        if (this.getBackupPageParam(this.nomPage, false)) {
            this.filtreActif = this.filtresService.restoreFiltreActif(this.nomPage);
            this.filtreService = this.filtresService.restoreFiltreService(this.nomPage);
            this.filtreHorsZone = this.filtresService.restoreFiltreHorsZone(this.nomPage);
            this.filtreServActif = this.filtresService.restoreFiltreServiceActif(this.nomPage);
        } else {
            // filtre Service
            this.filtreService = await this.filtresService.getFiltreRFService();
        }

        // Récupération de la liste agents
        await this.initListElement();
    }

    public async initListElement() {
        const listePFClient: Client[] = await lastValueFrom(this.wsClient.getClientsByAgent(this.idAgent));
        this.setListeADV(listePFClient);

        this.fSetListeElements(listePFClient);
    }

    public setListeADV(list: ClientAdv[]) {
        /*
        Pour les fonctions de tri on a besoin d'avoir un seul champ de donnée
        On ne peux pas avoir a l'affichage "CP + VILLE" et faire le tri que sur la valeur CP
        ou le contact avec NOM + PRENOM...
        */
        for (const elem of list) {
            elem.CPVILLE = elem.COPOST + " - " + elem.COMMUNE;
            if (elem.CONTACTS.length > 0) {
                elem.CONTACT_NOMPRENOM = elem.CONTACTS[0].NOM + " " + elem.CONTACTS[0].PRENOM;
                elem.CONTACT_TEL1 = this.util.telephone.affFormatedTel(elem.CONTACTS[0].TELA);
                elem.CONTACT_TEL2 = this.util.telephone.affFormatedTel(elem.CONTACTS[0].TELB);
            }
        }
    }


    public checkCreer() {
        return this.droitsAccess.write;
    }

    public checkExport() {
        return true;
    }

    public fClicRetour() {
        this.retour();
    }

    public checkRetour() {
        return true;
    }

    public hasAccessFicheClient() {
        return this.hasAccesModule(Constantes.CodeOption.CFICHECLIENT);
    }

    /**
     * Permet d'ouvrir la fenêtre de l'option choisie (inventaire, données générales...)
     */
    public nouvellePage($event: number, client: ClientAdv) {
        if ($event == 1) {
            this.dialog.open(InventaireComponent, {
                data: {
                    copaip: 'FR',
                    nuchep: client.NUCHEP,
                    idClient: client.IDCLIENT
                } as InventaireComponentData
            });
        } else if ($event == 2) {
            this.saveParamPage();

            this.router.navigate(['/services', 'FR', client.NUCHEP, client.IDCLIENT]).catch(e => this.util.fErreur(e));
        } else if ($event == 3) {
            this.saveParamPage();
            this.router.navigate(['/suiviactivite', 'client', client.IDCLIENT]).catch(e => this.util.fErreur(e));
        } else if ($event == 4) {
            this.util.fOpenFicheClient(client);
        }
    }

    public saveParamPage() {
        // Sauvegarde l'état de la page
        this.setBackupPageParam();
        this.filtresService.backupFiltreService(this.nomPage, this.filtreService);
        this.filtresService.backupFiltreActif(this.nomPage, this.filtreActif);
        this.filtresService.backupFiltreHorsZone(this.nomPage, this.filtreHorsZone);
        this.filtresService.backupFiltreServiceActif(this.nomPage, this.filtreServActif);
        this.saveBackupPageParam(this.nomPage);
    }

    /**
  * Méthode permettant d'afficher la fenêtre de modification d'un service en récupérant ses donénes
  * @param contact
  */
    editService(service: Service, client: Client) {
        this.clientSelectionne = client;
        this.ouvreFenetreDetail(service);
    }

    async delService(service: Service, client: Client) {
        const nuchep: string = client.NUCHEP;
        const idclient: number = client.IDCLIENT;
        if (await this.util.confirmation(this.translate.instant("APPCLIENT.DELSERV", { libelle: this.translate.instant("TYPESERVICE." + service.TYPESERVICE.CODESERV) }))) {
            try {
                this.util.showLoader();
                switch (service.TYPESERVICE.CODESERV) {
                    case 'PES': {
                        await lastValueFrom(this.wsServ.deleteServicePesee(nuchep, idclient, service.IDSERVICE));
                        break;
                    }
                    case 'HUB': {
                        await lastValueFrom(this.wsServ.deleteServiceDataHub(nuchep, idclient, service.ORGANISME.COSIG, service.IDSERVICE));
                        break;
                    }
                    case 'ANA': {
                        await lastValueFrom(this.wsServ.deleteServiceAna(nuchep, idclient, service.IDSERVICE));
                        break;
                    }
                    case 'SIG': {
                        await lastValueFrom(this.wsServ.deleteServiceSig(nuchep, idclient, service.IDSERVICE));
                        break;
                    }
                    case 'MIR': {
                        await lastValueFrom(this.wsServ.deleteServiceMir(nuchep, idclient, service.IDSERVICE, service.DDEBUT));
                        break;
                    }
                    case 'MAS': {
                        await lastValueFrom(this.wsServ.deleteService(nuchep, idclient, service.IDSERVICE));
                        break;
                    }
                }
                //on supprime l'element de la liste
                this.listeElements.forEach((o: Client) => {
                    if (o.IDCLIENT == idclient) {
                        if (o.SERVICES.length > 0) {
                            o.SERVICES.splice(o.SERVICES.findIndex((s: Service) => {
                                return s.IDSERVICE == service.IDSERVICE;
                            }), 1);
                        }
                    }
                });
                this.fReloadListe();
            } catch (e) {
                this.util.fErreur(e);
            } finally {
                this.util.hideLoader();
            }
        }
    }

    public savedService(serv: Service) {
        const client = this.clientSelectionne;


        //on verifie que ce soit toujours le meme agent (si ce n'est plus le cas on vire carrément le service)
        if (serv.AGENT?.USRID != this.idAgent) {
            //on supprime l'element de la liste
            this.listeElements.forEach((o: Client) => {
                if (o.IDCLIENT == client.IDCLIENT) {
                    if (o.SERVICES.length > 0) {
                        o.SERVICES.splice(o.SERVICES.findIndex((s: Service) => {
                            return s.IDSERVICE == serv.IDSERVICE;
                        }), 1);
                    }
                }
            });
        } else {
            const index = this.getListeElements().findIndex((o: Client) => {
                return o.IDCLIENT == client.IDCLIENT;
            });
            if (index != -1) {
                if (this.getElementFromListe<Client>(index).SERVICES == null) {
                    this.getElementFromListe<Client>(index).SERVICES = [];
                }
                const index2 = this.getElementFromListe<Client>(index).SERVICES.findIndex((o: Service) => {
                    return o.IDSERVICE == serv.IDSERVICE;
                });
                if (index2 > -1) {
                    this.getElementFromListe<Client>(index).SERVICES.splice(index2, 1, serv);
                } else {
                    this.getElementFromListe<Client>(index).SERVICES.push(serv);
                }
            }
        }
        this.fReloadListe();
    }

    /**
     * Méthode permettant de sélectionné le service qu'on veut créer et d'ouvrir la fenêtre correspondante
     */
    public openService(rfService: RFService) {
        const client = this.clientSelectionne;
        if (this.droitsAccess.write) {
            const service: Service = {
                TYPESERVICE: rfService,
                CLIENT: {
                    IDCLIENT: client.IDCLIENT
                },
                NUCHEP: client.NUCHEP
            };
            this.ouvreFenetreDetail(service);
        }
    }

    private ouvreFenetreDetail(service: Service) {
        const dialService = this.dialog.open(ServiceDetailsComponent, {
            data: {
                service: service,
                client: this.clientSelectionne
            } as ServiceDetailsComponentData
        });
        dialService.componentInstance.saved.subscribe((serv) => {
            this.savedService(serv);
        });
    }

    /**
     *
    Methode qui permet d ecreer un service pour un client, on recuepre dabord tout les services du client meme ceux appartenant a un autre referent
     * @param client
     */
    public async openCreerService(client: Client) {
        this.util.showLoader();
        try {
            this.clientSelectionne = client;
            // on recupere TOUT les services du client au cas ou un autre referent soit deja present
            const clWS: Client = { SERVICES: await lastValueFrom(this.wsServ.getALLServicesByClient(client.NUCHEP, client.IDCLIENT)) };
            if (this.droitsAccess.write) {
                // Charge la liste des services au cas où elle ne soit pas déjà en mémoire
                if (!this.listRfServices) {
                    this.listRfServices = await lastValueFrom(this.wsCacheLow.getRFServices());
                }

                if (clWS.SERVICES != null) {
                    this.listeTypeServ = this.listRfServices.filter((o: RFService) => {
                        return clWS.SERVICES.filter((o1: Service) => { return o1.TYPESERVICE.CODESERV == o.CODESERV && this.util.date.compareTodayDate(o1.DDEBUT, o1.DFIN); }).length == 0;
                    });
                } else {
                    this.listeTypeServ = this.listRfServices;
                }
                const dialogCreer = this.dialog.open(CreerService, {
                    data: {
                        listeTypeServ: this.listRfServices,
                        client: this.clientSelectionne
                    } as CreerServiceData
                });
                dialogCreer.componentInstance.rfService.subscribe((rfservice) => {
                    this.openService(rfservice);
                });
            } else {
                this.util.fErreur(this.translate.instant("ACCESFONCTIONINTERDIT"));
            }
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    protected filtrage() {
        let listeTemp = this.getListeElements<ClientAdv>();

        let boOK = false;

        //ON COMMENCE PAR LES FILTRES SIMPLE POUR DEJA REDUIRE LA LSITE
        if (FiltreHelper.isFiltrageNecessaire(this.filtreActif)) {
            listeTemp = listeTemp.filter((c: ClientAdv) => {
                boOK = false;
                this.filtreActif.forEach((f) => {
                    if (f.filtre == true && ((FiltreHelper.OuiNon.OUI === f.value) === (c.ACTIFUL === 1))) {
                        boOK = true;
                    }
                });
                return boOK;
            });
        }

        if (FiltreHelper.isFiltrageNecessaire(this.filtreHorsZone)) {
            listeTemp = listeTemp.filter((c: ClientAdv) => {
                boOK = false;
                this.filtreHorsZone.forEach((f) => {
                    if (f.filtre == true && ((FiltreHelper.OuiNon.OUI === f.value) === (c.HORSZONE === 1))) {
                        boOK = true;
                    }
                });
                return boOK;
            });
        }


        // filtre par organisme
        //On vérifie si tout les filtre sont a true ou false
        if (FiltreHelper.isFiltrageNecessaire(this.filtreOrganisme)) {
            const selectionOrga = FiltreHelper.getSelectionAsNumber(this.filtreOrganisme);
            listeTemp = listeTemp.filter((data: ClientAdv) => {
                boOK = false;
                data.SERVICES.forEach((serv: Service) => {
                    if (selectionOrga.includes(serv.ORGANISME.IDORGA)) {
                        boOK = true;
                    }
                });
                return boOK;
            });
        }

        // filtre par service
        //On vérifie si tout les filtre sont a true ou false
        if (FiltreHelper.isFiltrageNecessaire(this.filtreService)) {
            listeTemp = listeTemp.filter((data: ClientAdv) => {
                boOK = false;
                this.filtreService.forEach((f) => {
                    if (f.filtre == true) {
                        if (FiltreHelper.isFiltrageAucunEtValide(f, data.SERVICES) || (data.SERVICES != null
                            && data.SERVICES.filter((o) => { return o.TYPESERVICE.CODESERV == f.value; }).length > 0)) {
                            boOK = true;
                        }
                    }
                });
                return boOK;
            });
        }

        if (FiltreHelper.isFiltrageNecessaire(this.filtreServActif)) {
            const list: ClientAdv[] = [];
            listeTemp.forEach((c: ClientAdv) => {
                if (c.SERVICES == null || c.SERVICES.length === 0) {
                    // Sans service rattaché, on considère que ce client est éligible par défaut
                    list.push(c);
                } else {
                    const client = Object.assign({}, c);
                    client.SERVICES = [];
                    this.filtreServActif.forEach((f) => {
                        if (f.filtre == true && c.SERVICES != null) {
                            client.SERVICES = client.SERVICES.concat(Object.assign([], c.SERVICES.filter((o) => {
                                return (FiltreHelper.OuiNon.OUI === f.value) === (o.ACTIF === 1);
                            })));
                        }
                    });
                    if (client.SERVICES.length > 0) {
                        list.push(client);
                    }
                }
            });
            listeTemp = list;
        }

        if (FiltreHelper.isFiltrageNecessaire(this.filtreTypeReferent)) {
            const list: ClientAdv[] = [];
            listeTemp = listeTemp.filter((c: ClientAdv) => {
                const client = Object.assign({}, c);
                client.SERVICES = [];
                this.filtreTypeReferent.forEach((f) => {
                    if (f.filtre == true) {
                        // TODO: Ajouter enum
                        switch (f.value) {
                            case "RSP":
                                if (c.SERVICES) {
                                    client.SERVICES = client.SERVICES.concat(Object.assign([], c.SERVICES.filter((s: Service) => {
                                        return s.AGENT.USRID == this.idAgent;
                                    })));
                                }
                                break;
                            case "RSS":
                                if (c.SERVICES) {
                                    boOK = false;
                                    client.SERVICES = client.SERVICES.concat(Object.assign([], c.SERVICES.filter((s: Service) => {
                                        if (s.AGENTSUPP != null) {
                                            s.AGENTSUPP.forEach((u: Utilisateur) => {
                                                if (u.USRID == this.idAgent) {
                                                    boOK = true;
                                                }
                                            });
                                        }
                                        return boOK;
                                    })));
                                }
                                break;
                            case "RC":
                                if (client.REFERENT.USRID == this.idAgent) {
                                    client.SERVICES = Object.assign([], c.SERVICES);
                                }
                                break;
                        }
                    }
                });
                if (client.SERVICES.length > 0) {
                    list.push(client);
                }
            });
            listeTemp = list;
        }
        this.filtresService.backupFiltreOrga(this.filtreOrganisme);
        return listeTemp;

    }

    private async refreshAff() {
        this.util.showLoader();
        try {
            await this.initListElement();
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }


    // Exportation de la liste des Agents
    public fClicExporter() {
        if (this.getListeFiltree().length <= 0) {
            this.util.showToastWarning(this.translate.instant("EXPORTCSVNO"));
        } else {
            this.util.fConfirm(this.translate.instant("EXPORTCSV", { libelle: this.translate.instant("APPPORTEFEUILLECLIENT.CLIENTS").toLowerCase() }), () => {
                const tabExport: {
                    CODE: string,
                    NOM: string,
                    COMMUNE: string
                    INTERLOCUTEUR: string,
                    TEL1: string,
                    TEL2: string,
                    MAIL: string
                }[] = [{
                    CODE: this.translate.instant("APPPORTEFEUILLECLIENT.COLTAB.CODE"),
                    NOM: this.translate.instant("APPPORTEFEUILLECLIENT.COLTAB.NOM"),
                    COMMUNE: this.translate.instant("MUNICIPALITY"),
                    INTERLOCUTEUR: this.translate.instant("APPPORTEFEUILLECLIENT.COLTAB.INTERLOCUTEUR"),
                    TEL1: this.translate.instant("APPPORTEFEUILLECLIENT.COLTAB.TEL1"),
                    TEL2: this.translate.instant("APPPORTEFEUILLECLIENT.COLTAB.TEL2"),
                    MAIL: this.translate.instant("MAIL")
                }];

                // On transfert juste les données utilises dans le tableau pour export
                this.getListeFiltree<ClientAdv>().forEach((pfClient) => {
                    tabExport.push({
                        CODE: pfClient.NUCHEP,
                        NOM: pfClient.NOM,
                        COMMUNE: pfClient.CPVILLE,
                        INTERLOCUTEUR: pfClient.CONTACT_NOMPRENOM,
                        TEL1: (pfClient.CONTACT_TEL1) ? pfClient.CONTACT_TEL1 : "",
                        TEL2: (pfClient.CONTACT_TEL2) ? pfClient.CONTACT_TEL2 : "",
                        MAIL: pfClient.CONTACTS[0].MAIL
                    });
                });

                this.downloadCSV(tabExport, "GALACLICK_" + this.translate.instant("APPPORTEFEUILLECLIENT.TITRE") + "_" + UtilDate.getDate_time());
            });
        }
    }

    public async onMoveClientMultiModal() {
        await this.refreshAff();
    }

    /**
     * Méthode permettant de reset la liste affichée lors d'un modification dans celle-ci
     *  client crée ou modifié
     */
    private async onBDDChanges(client: Client) {
        //this.util.showLoader();
        if (client != null) {
            await this.chargeListe();
        }
    }
}
